import { useMutation, useQuery, useQueryClient } from "react-query";
import EmailTemplateService from "services/emailTemplate.services";

export const useGetAllEmailTemplates = (filterData, mo = false) => {
  return useQuery(
    ["email-templates", { filterData }],
    () => EmailTemplateService.getAllEmailTemplates(filterData),
    {
      keepPreviousData: true,
      staleTime: 60 * 60 * 1000,
    }
  );
};

export const useSaveDefaultEmailTemplates = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) => EmailTemplateService.saveDefaultEmailTemplates(body),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("saveDefaultEmailTemplates");
      },
    }
  );
};